<script>
    import {Map} from "vue2-google-maps";

    const styles = require("./styles");

    export default {
        extends: Map,
        props: {
            center: {
                default: () => {
                    return {lat: 38.890286, lng: -77.0394031} // Washington Monument
                },
            },
            zoom: {
                default: 12,
            },
        },
        methods: {
            setOptions(options) {
                this.$mapPromise.then((map) => {
                    map.setOptions(Object.assign({}, {
                        zoomControl: true,
                        mapTypeControl: false,
                        scaleControl: false,
                        streetViewControl: true,
                        rotateControl: false,
                        fullscreenControl: true,
                        gestureHandling: 'auto',
                        styles: styles,
                        maxZoom: null,
                    }, options));
                });
            }
        }
    }
</script>
